import { isNil } from 'lodash-es';
import { log } from '@hotjar/insights-common/lib/log';

export const isAvailable = (): boolean => {
  return !isNil(window.hj) && !isNil(window.hjSiteSettings);
};

export const tagRecording = (tag: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Tagging recording with "${tag}"`);
    window.hj('tagRecording', [tag]);
  }
};

export const trigger = (trig: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Javascript trigger "${trig}"`);
    window.hj('trigger', trig);
  }
};

/**
 * Track a Virtual Page View.
 */
export const trackVirtualPageView = (path: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Tracking virtual page view ${path}`);
    window.hj('vpv', path);
  }
};

export const event = (actionName: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Event firing ${actionName}`);
    window.hj('event', actionName);
  }
};

export const identify = (userId: number, props: Record<string, unknown>): void => {
  if (window.hj) {
    log.debug(`Hotjar: Identify with ${userId} and ${props}`);
    window.hj('identify', userId, props);
  }
};

export const sessionEvent = (props: Record<string, unknown>): void => {
  if (window.hj) {
    log.debug(`Hotjar: Session event ${props}`);
    window.hj('session_event', props);
  }
};
